import React, { VFC } from 'react';
import styled from 'styled-components';
import { IIconProps } from './types';

const Wrapper = styled.div`
  display: block;
  margin: auto auto;
`;

const LoadingIcon: VFC<IIconProps> = ({ color, size }) => (
  <Wrapper>
    <svg
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 12a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11h-2a9 9 0 1 1-18 0Z"
        fill={color}
      />
    </svg>
  </Wrapper>
);

export default LoadingIcon;
